/**
 * Bounds a number to a specified range
 * @param min - Minimum value
 * @param num - Number to bound
 * @param max - Maximum value
 * @returns The bounded number
 */
export const boundNumberToRange = (min: number, num: number, max: number) =>
  Math.min(Math.max(num, min), max);

/**
 * Bounds a number to a maximum value
 * @param num - Number to bound
 * @param max - Maximum value
 * @returns The bounded number
 */
export const upperBoundedNumber = (num: number, max: number) =>
  Math.min(num, max);

/**
 * Bounds a number to a minimum value
 * @param min - Minimum value
 * @param num - Number to bound
 * @returns The bounded number
 */
export const lowerBoundedNumber = (min: number, num: number) =>
  Math.max(min, num);
